import { useLeaseCompStore, useMapMarkerStore, usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import ILeaseComp, { ILeaseCompState } from "../interfaces/ILeaseComp";

const useLeaseCompUpdate = (): (leaseComp: ILeaseComp, leaseCompState: ILeaseCompState) => Promise<void> => {
    const leaseCompStore = useLeaseCompStore();
    const pipedriveStore = usePipedriveStore();
    const mapMarkerStore = useMapMarkerStore();

    return async (leaseComp: ILeaseComp, leaseCompState: ILeaseCompState): Promise<void> => {
        try {
            await leaseCompStore.updateLeaseComp({
                ...leaseComp,
                ...leaseCompState,
                address: leaseCompState.address!,
                totalRent: leaseCompState.totalRent!,
                pipedriveCompanyId: await pipedriveStore.getOrCreatePipedriveOrganizationId(leaseCompState.pipedriveCompanyName),
                centerPoint: mapMarkerStore.coordinates!,
            });

            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeaseCompUpdate;